<template lang="pug">
.roll: .roll-main(ref='body')
  CookieBanner
  #Kerdoiv.app.urlap.screen
    vue-headful(title="Ajánlatkérés - Forex kft.")
    .header.content
      .logo: a(href='/'): img#logo(src='./xado-logo.png')
      .page-title Ajánlatkérés

    .content.form.loading-block(:class='{"is-loading": form.loading}')
      span(v-if='!form.submitted')
        p Kérjük, hogy adja meg a gépkocsi adatait. Ezek alapján kollégáink kiválasztják az Ön autójába javasolt motorolajat. Nem csak a viszkozitást vesszük figyelembe, hanem a  gyári előírásokat és egyéb műszaki paramétereket is. Így Ön biztos lehet benne, hogy az általunk javasolt olaj tökéletes választás az Ön autójához.
        p Miért fordítunk erre kiemelt figyelmet? Miért nem elég információ az , ha egy olajról csak annyit mondunk, hogy az Ön autójába pl : 5W-30 olaj kell ?
        p Azonos viszkozitású olajak esetén is óriási különbségek lehetnek a technikai paraméterekben. Ha csak a viszkozitás megfelelő, de pl. nem fordítunk figyelmet a szulfáthamu tartalomra, az okozhatja dízel autók esetén DPF szűrő eltömődését. A kínálatra jellemző, hogy pl. az 5W-30 viszkozitású olajból nálunk 6 féle kapható, melyek egyéb műszaki paraméterei különböznek.
        p Javasoljuk, hogy az olaj kiválasztását bízza szakemberre.

        form(@submit.prevent='submit()')
          FormMezo(v-for='mezo in form.mezok', :mezo='mezo', :model='model')
          .error(v-if='form.error')
            .message.is-danger
              .message-body(v-if='form.error.validation') Egy vagy több mező nem megfelelően van kitöltve.
              .message-body(v-else) Hiba történt az űrlap elküldése során.
          .has-text-centered
            button.submit.button.is-primary(type='submit' v-show='!form.submitted && valid') Beküldés
          span(v-if='recaptchaLoaded')
            | Amennyiben nem találja autóját a listában kérem 
            a(href='javascript:void(0)' @click='sendEmail()') kattintson ide
            |  majd az ellenőrzés után megjelenő email címre küldje el járműve adatait.
            |  (pl: Gyártó: Opel; Típus: Astra; Évjárat: 2019; Motor: 0.9 turbo)
            div(id='captcha')
          span(v-if='emailLink.length > 0')
            | Levelezési címünk:  
            a(:href='"mailto:" + emailLink') {{ emailLink }}
      .done(v-else)
        p Köszönjük, hogy megtisztelt minket bizalmával és ránk bízta az olajválasztást gépjárművéhez.
        p Fontos, hogy nem kizárólag a viszkozitás alapján ajánlunk motorolajat , hanem figyelembe vesszük az  API és ACEA teljesítményszinteket és az egyéb műszaki paramétereket.  (TBN szám, szulfáthamu mennyiség). Így Ön biztos lehet benne, hogy bármely általunk ajánlott olaj tökéletes választás.
        p Természetesen a XADO  motorolajok megfelelnek szinte minden gyártó saját minősítéseinek és ezeket is figyelembe vesszük a kiválasztáskor.
        p Így lehetünk biztosak abban, hogy az általunk ajánlott olaj minden tekintetben teljesíti az gyári előírásokat, megfelelő kenést és védelmet biztosít  az gépkocsi motorjának.
        p Kollégáink kiválasztják  a megfelelő olajtípusokat és ajánlatunkat  1-2 napon belül küldjük.
        .has-text-centered
          .button(@click='close()') Bezárás

    ConfirmDialog
  
</template>

<script>

import {AjanlatKeres} from '../ajanlatkeres/AjanlatKeres.js'
import FormMezo from '../form/FormMezo.vue'
import {KerdoivService} from "./KerdoivService.js";
import {OlajService} from "./OlajService.js";
import ConfirmDialog from '../app/ConfirmDialog.vue'
import {fbq, gtag} from "../app/Analytics.js";
import CookieBanner from "./CookieBanner.vue";


export default {
  data: () => ({
    model: AjanlatKeres.create(),
    form: AjanlatKeres.form({
      disabled: false,
      submitted: false,
      loading: false,
      error: false
    }),
    recaptchaLoaded: false,
    emailLink: '',
    valid: false
  }),
  components: { FormMezo, ConfirmDialog, CookieBanner },
  name: "Kerdoiv",
  created() {
    this.service = new KerdoivService(this.model);
    this.olajservice = new OlajService(this.model);
    this.GetGyártmányok();
    this.$watch(function() { return this.model.Gyártmány; }, this.GetModellek);
    this.$watch(function() { return this.model.Modell; }, this.GetTípusok);
    this.$watch(function() { return this.model.Típus; }, this.UpdateValid);

    fbq('init', '1494928380806306');
    fbq('track', 'PageView');
    gtag('config', 'UA-3595668-1');

  },
  mounted() {
    var recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js?render=explicit')
    recaptchaScript.async = true;
    recaptchaScript.defer = true;
    recaptchaScript.onload = this.recaptchaLoadedCallback;
    document.head.appendChild(recaptchaScript);
  },
  methods: {
    async submit()
    {
      this.form.disabled = true;
      this.form.error = false;
      this.form.loading = true;
      this.form.state();
      
      try {
        const hasAjanlat = await this.service.CheckExistingAjánlatKérésForEmail();
        this.form.loading = false;
        
        if(hasAjanlat)
          await this.$confirm("Önnek már volt regisztrált gépjárműve a rendszerünkben. A mostani adatokkal kívánja korábbi adatait felülírni?");

        await this.send()
      }
      
      catch(err) {
        this.form.disabled = false;
        if(err === false) return;
        
        this.form.state(err.validation);
        this.form.error = err;
        this.scrollTo('.error');
      }
      finally {
        this.form.loading = false;
      }
    },

    async send()
    {
      this.form.loading = true;

      await this.service.SendAjánlatKérés();
      this.form.submitted = true;
      fbq('track', 'Lead');
      gtag('event', 'Lead');

      this.scrollTo('.done');

    },
    
    async sendEmail()
    {
      var siteKey = await this.service.GetCaptcha();
      grecaptcha.render('captcha', {
          'sitekey' : siteKey,
          'callback' : this.recaptchaVerifyCallback,
      });
    },

    recaptchaLoadedCallback()
    {
      this.recaptchaLoaded = true;
    },

    async recaptchaVerifyCallback()
    {
      this.form.loading = true;
      this.emailLink = await this.service.VerifyCaptcha(grecaptcha.getResponse());
      this.form.loading = false;
    },

    finish() 
    {
      
    },
    
    close() {
      location.href = 'https://xado.hu'
    },
    
    scrollTo(selector) {
      this.$nextTick(() => {
        const el = this.$el.querySelector(selector);
        this.$refs.body.scrollTop = el.offsetTop;
      })
    },
  
    async GetGyártmányok()
    {
        var placeholder = this.form.mezok[1].options[0];
        this.model.Gyártmány = placeholder;
        var options = await this.olajservice.SendGetGyártmányok();
        options.unshift(placeholder);
        this.form.mezok[1].options = options;
    },
    async GetModellek()
    {
        var placeholder = this.form.mezok[2].options[0];
        this.model.Modell = placeholder;
        var options = [];
        if (this.model.Gyártmány != null && !this.model.Gyártmány.startsWith("-"))
            options = await this.olajservice.SendGetModellek();
        options.unshift(placeholder);
        this.form.mezok[2].options = options;
    },
    async GetTípusok()
    {
        var placeholder = this.form.mezok[3].options[0];
        this.model.Típus = placeholder;
        var options = [];
        if (this.model.Modell != null && !this.model.Modell.startsWith("-"))
            options = await this.olajservice.SendGetTípusok();
        options.unshift(placeholder);
        this.form.mezok[3].options = options;
    },
    async GetGyártásiÉvek()
    {
        var placeholder = this.form.mezok[4].options[0];
        this.model.GyártásiÉv = placeholder;
        var options = [];
        if (this.model.Típus != null && !this.model.Típus.startsWith("-"))
            options = await this.olajservice.SendGetGyártásiÉvek();
        options.unshift(placeholder);
        this.form.mezok[4].options = options;
    },
    async UpdateValid()
    {
        var placeholder = this.form.mezok[3].options[0];
        this.valid = (this.model.Modell != null && !this.model.Modell.startsWith("-"));
    },

  },
  
}
</script>

<style lang='sass'>
@import "../app/main.sass"

#Kerdoiv
  .page-title
    background: #ED1C24
  .logo
    flex: 1
  #logo
    height: 100%
    
  .FormMezo a
    text-decoration: underline
        
        
.error
  margin: 1rem 0
</style>
